import { z } from 'zod'

const mediaSchema = z.object({
  url: z.string(),
  type: z.enum(['PHOTO', 'VIDEO']),
  alt: z.string(),
  width: z.number().int().nullable(),
  height: z.number().int().nullable(),
})

export const schema = z.object({
  medias: z.array(mediaSchema),
  total: z.number().int(),
})

export type schemaType = z.infer<typeof schema>
export type MediaType = z.infer<typeof mediaSchema>
